import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
export default function LoadingEmptySpace({
  label = ""
}) {
  return <>
      <Box data-sentry-element="Box" data-sentry-source-file="LoadingEmptySpace.tsx">
        <Flex justify="center" align="center" h="100vh" direction="column" data-sentry-element="Flex" data-sentry-source-file="LoadingEmptySpace.tsx">
          <Spinner thickness="4px" speed="0.5s" emptyColor="gray.200" color="bluefrance.500" size="xl" data-sentry-element="Spinner" data-sentry-source-file="LoadingEmptySpace.tsx" />
          <Text data-sentry-element="Text" data-sentry-source-file="LoadingEmptySpace.tsx">{label}</Text>
        </Flex>
      </Box>
    </>;
}